import { GraphQLResolveInfo } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['String']['output'];
  has2fa: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AdminLog = {
  __typename?: 'AdminLog';
  action: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type AutoSwap = {
  __typename?: 'AutoSwap';
  finalAddress: Whitelist;
  fromMint: Mint;
  immediate: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
  rollSwap: Scalars['Boolean']['output'];
  toMint: Mint;
};

export type Balance = {
  __typename?: 'Balance';
  credit: Scalars['String']['output'];
  mint: Scalars['String']['output'];
  mintId: Scalars['Int']['output'];
};

export enum Chain {
  Btc = 'BTC',
  Eth = 'ETH',
  Sol = 'SOL',
  Tron = 'TRON'
}

export type CreateUser = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  role: Role;
  username: Scalars['String']['input'];
};

export enum Decision {
  Approved = 'Approved',
  Pending = 'Pending',
  Redirected = 'Redirected',
  Rejected = 'Rejected'
}

export type DepositAddress = {
  __typename?: 'DepositAddress';
  address: Scalars['String']['output'];
  chain: Chain;
};

export type Failure = {
  __typename?: 'Failure';
  createdAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
};

export type Mint = {
  __typename?: 'Mint';
  chain: Chain;
  id: Scalars['Int']['output'];
  img?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTopup: Topup;
  addUserToOrganization: Organization;
  addWhitelist: Organization;
  createAutoSwap: AutoSwap;
  createOrganization: Organization;
  createUser: User;
  deleteAutoSwap: Scalars['Boolean']['output'];
  deleteFailure: Scalars['Boolean']['output'];
  executeAutoSwap: Scalars['Boolean']['output'];
  logout: Scalars['Boolean']['output'];
  redirectTopup: Topup;
  rejectTopup: Topup;
  removeUserFromOrganization: Organization;
  removeWhitelist: Organization;
  requestTwoFactorAuth: Scalars['String']['output'];
  resetPassword: User;
  retryFailure: Scalars['Boolean']['output'];
  sendTestAlertForOrganization: Scalars['Boolean']['output'];
  setupTwoFactorAuth: Admin;
  toggleOrganizationAutoApprove: Organization;
  toggleTakeExtraFee: Organization;
  updateAlertForOrganization: Organization;
  updateEmailForOrganization: Organization;
  updateUserRoleInOrganization: Organization;
  updateWhitelistName: Organization;
  zeroOutBalance: Scalars['Boolean']['output'];
};


export type MutationAcceptTopupArgs = {
  topupId: Scalars['String']['input'];
};


export type MutationAddUserToOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationAddWhitelistArgs = {
  address: Scalars['String']['input'];
  chain: Chain;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationCreateAutoSwapArgs = {
  endAddress: Scalars['Int']['input'];
  fromMintId: Scalars['Int']['input'];
  hoursBeforeExecution?: InputMaybe<Scalars['Int']['input']>;
  immediate: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  rollSwap: Scalars['Boolean']['input'];
  toMintId: Scalars['Int']['input'];
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  user: CreateUser;
};


export type MutationDeleteAutoSwapArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeleteFailureArgs = {
  id: Scalars['Int']['input'];
};


export type MutationExecuteAutoSwapArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationRedirectTopupArgs = {
  address: Scalars['String']['input'];
  topupId: Scalars['String']['input'];
};


export type MutationRejectTopupArgs = {
  topupId: Scalars['String']['input'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveWhitelistArgs = {
  id: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRetryFailureArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSendTestAlertForOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationSetupTwoFactorAuthArgs = {
  secret: Scalars['String']['input'];
};


export type MutationToggleOrganizationAutoApproveArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationToggleTakeExtraFeeArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateAlertForOrganizationArgs = {
  alertSecret: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateEmailForOrganizationArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateUserRoleInOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationUpdateWhitelistNameArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationZeroOutBalanceArgs = {
  mintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  alertSecret: Scalars['String']['output'];
  autoApprove: Scalars['Boolean']['output'];
  depositAddresses: Array<DepositAddress>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  takeExtraFee: Scalars['Boolean']['output'];
  whitelist: Array<Whitelist>;
};

export type OrganizationPermission = {
  __typename?: 'OrganizationPermission';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: Role;
};

export type OrganizationWithPendingTopups = {
  __typename?: 'OrganizationWithPendingTopups';
  autoApprove: Scalars['Boolean']['output'];
  hasBalance: Scalars['Boolean']['output'];
  hasPendingTopups: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  takeExtraFee: Scalars['Boolean']['output'];
  whitelist: Array<Whitelist>;
};

export type Query = {
  __typename?: 'Query';
  getAllOrganizations: Array<Organization>;
  getAllTopupHistory: Array<Topup>;
  getAllUsers: Array<User>;
  getAutoSwap?: Maybe<AutoSwap>;
  getBalance: Array<Balance>;
  getEthGasWallet: Scalars['String']['output'];
  getFailures: Array<Failure>;
  getLogHistoryOfAdmin: Array<AdminLog>;
  getLogHistoryOfUser: Array<UserLog>;
  getMe: Admin;
  getMints: Array<Mint>;
  getNonce: Scalars['Int']['output'];
  getOrganization: Organization;
  getOrganizations: Array<OrganizationWithPendingTopups>;
  getStepLogs: Array<StepLog>;
  getSwap: Swap;
  getSwaps: Array<Swap>;
  getSwapsOfOrganization: Array<Swap>;
  getTopupHistory: Array<Topup>;
  getTransientTopups: Array<Topup>;
  getUser: UserWithOrg;
  getUsersOfOrganization: Array<UserInOrg>;
};


export type QueryGetAllTopupHistoryArgs = {
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAutoSwapArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetBalanceArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetLogHistoryOfAdminArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetLogHistoryOfUserArgs = {
  page: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetOrganizationsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetStepLogsArgs = {
  swapId: Scalars['String']['input'];
};


export type QueryGetSwapArgs = {
  swapId: Scalars['String']['input'];
};


export type QueryGetSwapsArgs = {
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSwapsOfOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetTopupHistoryArgs = {
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetTransientTopupsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUsersOfOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export enum Role {
  Swap = 'Swap',
  View = 'View'
}

export type StepLog = {
  __typename?: 'StepLog';
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  swapId: Scalars['String']['output'];
};

export type Swap = {
  __typename?: 'Swap';
  date: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  endAddress: Scalars['String']['output'];
  fromAmount: Scalars['String']['output'];
  fromMint: Mint;
  id: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  status: SwapStatus;
  steps: Array<SwapStep>;
  toAmount?: Maybe<Scalars['String']['output']>;
  toMint: Mint;
  txHash?: Maybe<Scalars['String']['output']>;
};

export enum SwapStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending'
}

export type SwapStep = {
  __typename?: 'SwapStep';
  action: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPending: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type Topup = {
  __typename?: 'Topup';
  amount: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  decision: Decision;
  decisionAt?: Maybe<Scalars['String']['output']>;
  finalizedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lpTxHash?: Maybe<Scalars['String']['output']>;
  mint: Mint;
  txHash: Scalars['String']['output'];
};

export type UpdateUserOrgs = {
  organizationId: Scalars['String']['input'];
  role: Role;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type UserInOrg = {
  __typename?: 'UserInOrg';
  email: Scalars['String']['output'];
  role: Role;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type UserLog = {
  __typename?: 'UserLog';
  action: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type UserWithOrg = {
  __typename?: 'UserWithOrg';
  email: Scalars['String']['output'];
  organizations: Array<OrganizationPermission>;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Whitelist = {
  __typename?: 'Whitelist';
  address: Scalars['String']['output'];
  chain: Chain;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GetNonceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonceQuery = { __typename?: 'Query', getNonce: number };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'UserWithOrg', userId: string, username: string, email: string, organizations: Array<{ __typename?: 'OrganizationPermission', id: string, name: string, role: Role }> } };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'Query', getAllUsers: Array<{ __typename?: 'User', userId: string, username: string, email: string }> };

export type GetUsersOfOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetUsersOfOrganizationQuery = { __typename?: 'Query', getUsersOfOrganization: Array<{ __typename?: 'UserInOrg', userId: string, username: string, email: string, role: Role }> };

export type GetOrganizationsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'OrganizationWithPendingTopups', id: string, name: string, hasPendingTopups: boolean, autoApprove: boolean, takeExtraFee: boolean, hasBalance: boolean, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> }> };

export type GetOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', getOrganization: { __typename?: 'Organization', id: string, name: string, email?: string | null, autoApprove: boolean, alertSecret: string, takeExtraFee: boolean, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }>, depositAddresses: Array<{ __typename?: 'DepositAddress', chain: Chain, address: string }> } };

export type GetBalanceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetBalanceQuery = { __typename?: 'Query', getBalance: Array<{ __typename?: 'Balance', credit: string, mint: string, mintId: number }> };

export type GetAllOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganizationsQuery = { __typename?: 'Query', getAllOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> }> };

export type GetLogHistoryOfAdminQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;


export type GetLogHistoryOfAdminQuery = { __typename?: 'Query', getLogHistoryOfAdmin: Array<{ __typename?: 'AdminLog', id: number, username: string, action: string, date: string }> };

export type GetLogHistoryOfUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetLogHistoryOfUserQuery = { __typename?: 'Query', getLogHistoryOfUser: Array<{ __typename?: 'UserLog', id: number, username: string, action: string, date: string }> };

export type GetSwapsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
}>;


export type GetSwapsQuery = { __typename?: 'Query', getSwaps: Array<{ __typename?: 'Swap', id: string, fromAmount: string, toAmount?: string | null, txHash?: string | null, endAddress: string, status: SwapStatus, date: string, organizationName: string, depositAddress: string, fromMint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string }, toMint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string }, steps: Array<{ __typename?: 'SwapStep', id: number, action: string, date: string, status: string, isPending: boolean }> }> };

export type GetSwapQueryVariables = Exact<{
  swapId: Scalars['String']['input'];
}>;


export type GetSwapQuery = { __typename?: 'Query', getSwap: { __typename?: 'Swap', id: string, fromAmount: string, toAmount?: string | null, txHash?: string | null, endAddress: string, status: SwapStatus, date: string, organizationName: string, depositAddress: string, fromMint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string }, toMint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string }, steps: Array<{ __typename?: 'SwapStep', id: number, action: string, date: string, status: string, isPending: boolean }> } };

export type GetSwapsOfOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetSwapsOfOrganizationQuery = { __typename?: 'Query', getSwapsOfOrganization: Array<{ __typename?: 'Swap', id: string, fromAmount: string, toAmount?: string | null, txHash?: string | null, endAddress: string, status: SwapStatus, date: string, organizationName: string, depositAddress: string, fromMint: { __typename?: 'Mint', id: number, name: string, chain: Chain }, toMint: { __typename?: 'Mint', id: number, name: string, chain: Chain }, steps: Array<{ __typename?: 'SwapStep', id: number, action: string, date: string, status: string, isPending: boolean }> }> };

export type GetTransientTopupsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetTransientTopupsQuery = { __typename?: 'Query', getTransientTopups: Array<{ __typename?: 'Topup', id: string, amount: string, txHash: string, createdAt: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: Chain } }> };

export type GetTopupHistoryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetTopupHistoryQuery = { __typename?: 'Query', getTopupHistory: Array<{ __typename?: 'Topup', id: string, amount: string, txHash: string, lpTxHash?: string | null, createdAt: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null } }> };

export type GetAllTopupHistoryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
}>;


export type GetAllTopupHistoryQuery = { __typename?: 'Query', getAllTopupHistory: Array<{ __typename?: 'Topup', id: string, amount: string, txHash: string, lpTxHash?: string | null, createdAt: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null } }> };

export type GetMintsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMintsQuery = { __typename?: 'Query', getMints: Array<{ __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string }> };

export type GetAutoSwapQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetAutoSwapQuery = { __typename?: 'Query', getAutoSwap?: { __typename?: 'AutoSwap', immediate: boolean, rollSwap: boolean, fromMint: { __typename?: 'Mint', id: number, name: string, chain: Chain }, toMint: { __typename?: 'Mint', id: number, name: string, chain: Chain }, finalAddress: { __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null } } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe: { __typename?: 'Admin', username: string, email: string, has2fa: boolean } };

export type GetEthGasWalletQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEthGasWalletQuery = { __typename?: 'Query', getEthGasWallet: string };

export type GetFailuresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFailuresQuery = { __typename?: 'Query', getFailures: Array<{ __typename?: 'Failure', id: number, key: string, message?: string | null, error?: string | null, stack?: string | null, createdAt: string }> };

export type GetStepLogsQueryVariables = Exact<{
  swapId: Scalars['String']['input'];
}>;


export type GetStepLogsQuery = { __typename?: 'Query', getStepLogs: Array<{ __typename?: 'StepLog', id: number, message: string, date: string }> };

export type UpdateEmailForOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateEmailForOrganizationMutation = { __typename?: 'Mutation', updateEmailForOrganization: { __typename?: 'Organization', id: string, name: string, email?: string | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ResetPasswordMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'User', userId: string, username: string, email: string } };

export type CreateUserMutationVariables = Exact<{
  user: CreateUser;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', userId: string, username: string, email: string } };

export type CreateOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> } };

export type AddUserToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  role: Role;
}>;


export type AddUserToOrganizationMutation = { __typename?: 'Mutation', addUserToOrganization: { __typename?: 'Organization', id: string, name: string, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> } };

export type UpdateUserRoleInOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  role: Role;
}>;


export type UpdateUserRoleInOrganizationMutation = { __typename?: 'Mutation', updateUserRoleInOrganization: { __typename?: 'Organization', id: string, name: string, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> } };

export type RemoveUserFromOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type RemoveUserFromOrganizationMutation = { __typename?: 'Mutation', removeUserFromOrganization: { __typename?: 'Organization', id: string, name: string, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> } };

export type AddWhitelistMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  chain: Chain;
  address: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddWhitelistMutation = { __typename?: 'Mutation', addWhitelist: { __typename?: 'Organization', id: string, name: string, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> } };

export type RemoveWhitelistMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}>;


export type RemoveWhitelistMutation = { __typename?: 'Mutation', removeWhitelist: { __typename?: 'Organization', id: string, name: string, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> } };

export type UpdateWhitelistNameMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateWhitelistNameMutation = { __typename?: 'Mutation', updateWhitelistName: { __typename?: 'Organization', id: string, name: string } };

export type AcceptTopupMutationVariables = Exact<{
  topupId: Scalars['String']['input'];
}>;


export type AcceptTopupMutation = { __typename?: 'Mutation', acceptTopup: { __typename?: 'Topup', id: string, amount: string, txHash: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string } } };

export type RejectTopupMutationVariables = Exact<{
  topupId: Scalars['String']['input'];
}>;


export type RejectTopupMutation = { __typename?: 'Mutation', rejectTopup: { __typename?: 'Topup', id: string, amount: string, txHash: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string } } };

export type RedirectTopupMutationVariables = Exact<{
  topupId: Scalars['String']['input'];
  address: Scalars['String']['input'];
}>;


export type RedirectTopupMutation = { __typename?: 'Mutation', redirectTopup: { __typename?: 'Topup', id: string, amount: string, txHash: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number, name: string, chain: Chain, img?: string | null, symbol: string } } };

export type ToggleOrganizationAutoApproveMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ToggleOrganizationAutoApproveMutation = { __typename?: 'Mutation', toggleOrganizationAutoApprove: { __typename?: 'Organization', id: string, name: string, autoApprove: boolean, whitelist: Array<{ __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null }> } };

export type UpdateAlertForOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  alertSecret: Scalars['String']['input'];
}>;


export type UpdateAlertForOrganizationMutation = { __typename?: 'Mutation', updateAlertForOrganization: { __typename?: 'Organization', id: string, name: string, alertSecret: string } };

export type SendTestAlertForOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type SendTestAlertForOrganizationMutation = { __typename?: 'Mutation', sendTestAlertForOrganization: boolean };

export type CreateAutoSwapMutationVariables = Exact<{
  fromMintId: Scalars['Int']['input'];
  toMintId: Scalars['Int']['input'];
  endAddress: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  immediate: Scalars['Boolean']['input'];
  hoursBeforeExecution?: InputMaybe<Scalars['Int']['input']>;
  rollSwap: Scalars['Boolean']['input'];
}>;


export type CreateAutoSwapMutation = { __typename?: 'Mutation', createAutoSwap: { __typename?: 'AutoSwap', immediate: boolean, fromMint: { __typename?: 'Mint', id: number, name: string, chain: Chain }, toMint: { __typename?: 'Mint', id: number, name: string, chain: Chain }, finalAddress: { __typename?: 'Whitelist', id: number, chain: Chain, address: string, name?: string | null } } };

export type DeleteAutoSwapMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteAutoSwapMutation = { __typename?: 'Mutation', deleteAutoSwap: boolean };

export type ExecuteAutoSwapMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ExecuteAutoSwapMutation = { __typename?: 'Mutation', executeAutoSwap: boolean };

export type ToggleTakeExtraFeeMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ToggleTakeExtraFeeMutation = { __typename?: 'Mutation', toggleTakeExtraFee: { __typename?: 'Organization', id: string, name: string, takeExtraFee: boolean } };

export type ZeroOutBalanceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mintId: Scalars['Int']['input'];
}>;


export type ZeroOutBalanceMutation = { __typename?: 'Mutation', zeroOutBalance: boolean };

export type RequestTwoFactorAuthMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestTwoFactorAuthMutation = { __typename?: 'Mutation', requestTwoFactorAuth: string };

export type SetupTwoFactorAuthMutationVariables = Exact<{
  secret: Scalars['String']['input'];
}>;


export type SetupTwoFactorAuthMutation = { __typename?: 'Mutation', setupTwoFactorAuth: { __typename?: 'Admin', userId: string, username: string, email: string } };

export type RetryFailureMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RetryFailureMutation = { __typename?: 'Mutation', retryFailure: boolean };

export type DeleteFailureMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFailureMutation = { __typename?: 'Mutation', deleteFailure: boolean };


export const GetNonceDocument = gql`
    query GetNonce {
  getNonce
}
    `;

export function useGetNonceQuery(options?: Omit<Urql.UseQueryArgs<GetNonceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNonceQuery, GetNonceQueryVariables>({ query: GetNonceDocument, ...options });
};
export const GetUserDocument = gql`
    query GetUser($userId: String!) {
  getUser(userId: $userId) {
    userId
    username
    email
    organizations {
      id
      name
      role
    }
  }
}
    `;

export function useGetUserQuery(options: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetAllUsersDocument = gql`
    query GetAllUsers {
  getAllUsers {
    userId
    username
    email
  }
}
    `;

export function useGetAllUsersQuery(options?: Omit<Urql.UseQueryArgs<GetAllUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>({ query: GetAllUsersDocument, ...options });
};
export const GetUsersOfOrganizationDocument = gql`
    query getUsersOfOrganization($organizationId: String!, $page: Int!) {
  getUsersOfOrganization(organizationId: $organizationId, page: $page) {
    userId
    username
    email
    role
  }
}
    `;

export function useGetUsersOfOrganizationQuery(options: Omit<Urql.UseQueryArgs<GetUsersOfOrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>({ query: GetUsersOfOrganizationDocument, ...options });
};
export const GetOrganizationsDocument = gql`
    query GetOrganizations($page: Int!) {
  getOrganizations(page: $page) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
    hasPendingTopups
    autoApprove
    takeExtraFee
    hasBalance
  }
}
    `;

export function useGetOrganizationsQuery(options: Omit<Urql.UseQueryArgs<GetOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>({ query: GetOrganizationsDocument, ...options });
};
export const GetOrganizationDocument = gql`
    query GetOrganization($organizationId: String!) {
  getOrganization(organizationId: $organizationId) {
    id
    name
    email
    whitelist {
      id
      chain
      address
      name
    }
    autoApprove
    alertSecret
    depositAddresses {
      chain
      address
    }
    takeExtraFee
  }
}
    `;

export function useGetOrganizationQuery(options: Omit<Urql.UseQueryArgs<GetOrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>({ query: GetOrganizationDocument, ...options });
};
export const GetBalanceDocument = gql`
    query GetBalance($organizationId: String!) {
  getBalance(organizationId: $organizationId) {
    credit
    mint
    mintId
  }
}
    `;

export function useGetBalanceQuery(options: Omit<Urql.UseQueryArgs<GetBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBalanceQuery, GetBalanceQueryVariables>({ query: GetBalanceDocument, ...options });
};
export const GetAllOrganizationsDocument = gql`
    query GetAllOrganizations {
  getAllOrganizations {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
  }
}
    `;

export function useGetAllOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<GetAllOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>({ query: GetAllOrganizationsDocument, ...options });
};
export const GetLogHistoryOfAdminDocument = gql`
    query GetLogHistoryOfAdmin($page: Int!) {
  getLogHistoryOfAdmin(page: $page) {
    id
    username
    action
    date
  }
}
    `;

export function useGetLogHistoryOfAdminQuery(options: Omit<Urql.UseQueryArgs<GetLogHistoryOfAdminQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLogHistoryOfAdminQuery, GetLogHistoryOfAdminQueryVariables>({ query: GetLogHistoryOfAdminDocument, ...options });
};
export const GetLogHistoryOfUserDocument = gql`
    query GetLogHistoryOfUser($userId: String!, $page: Int!) {
  getLogHistoryOfUser(userId: $userId, page: $page) {
    id
    username
    action
    date
  }
}
    `;

export function useGetLogHistoryOfUserQuery(options: Omit<Urql.UseQueryArgs<GetLogHistoryOfUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLogHistoryOfUserQuery, GetLogHistoryOfUserQueryVariables>({ query: GetLogHistoryOfUserDocument, ...options });
};
export const GetSwapsDocument = gql`
    query GetSwaps($search: String, $page: Int!) {
  getSwaps(search: $search, page: $page) {
    id
    fromMint {
      id
      name
      chain
      img
      symbol
    }
    toMint {
      id
      name
      chain
      img
      symbol
    }
    fromAmount
    toAmount
    txHash
    endAddress
    status
    date
    steps {
      id
      action
      date
      status
      isPending
    }
    organizationName
    depositAddress
  }
}
    `;

export function useGetSwapsQuery(options: Omit<Urql.UseQueryArgs<GetSwapsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapsQuery, GetSwapsQueryVariables>({ query: GetSwapsDocument, ...options });
};
export const GetSwapDocument = gql`
    query GetSwap($swapId: String!) {
  getSwap(swapId: $swapId) {
    id
    fromMint {
      id
      name
      chain
      img
      symbol
    }
    toMint {
      id
      name
      chain
      img
      symbol
    }
    fromAmount
    toAmount
    txHash
    endAddress
    status
    date
    steps {
      id
      action
      date
      status
      isPending
    }
    organizationName
    depositAddress
  }
}
    `;

export function useGetSwapQuery(options: Omit<Urql.UseQueryArgs<GetSwapQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapQuery, GetSwapQueryVariables>({ query: GetSwapDocument, ...options });
};
export const GetSwapsOfOrganizationDocument = gql`
    query GetSwapsOfOrganization($organizationId: String!, $page: Int!) {
  getSwapsOfOrganization(organizationId: $organizationId, page: $page) {
    id
    fromMint {
      id
      name
      chain
    }
    toMint {
      id
      name
      chain
    }
    fromAmount
    toAmount
    txHash
    endAddress
    status
    date
    steps {
      id
      action
      date
      status
      isPending
    }
    organizationName
    depositAddress
  }
}
    `;

export function useGetSwapsOfOrganizationQuery(options: Omit<Urql.UseQueryArgs<GetSwapsOfOrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapsOfOrganizationQuery, GetSwapsOfOrganizationQueryVariables>({ query: GetSwapsOfOrganizationDocument, ...options });
};
export const GetTransientTopupsDocument = gql`
    query GetTransientTopups($organizationId: String!) {
  getTransientTopups(organizationId: $organizationId) {
    id
    amount
    mint {
      id
      name
      chain
    }
    txHash
    createdAt
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useGetTransientTopupsQuery(options: Omit<Urql.UseQueryArgs<GetTransientTopupsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTransientTopupsQuery, GetTransientTopupsQueryVariables>({ query: GetTransientTopupsDocument, ...options });
};
export const GetTopupHistoryDocument = gql`
    query GetTopupHistory($organizationId: String!, $page: Int!) {
  getTopupHistory(organizationId: $organizationId, page: $page) {
    id
    amount
    mint {
      id
      name
      chain
      img
    }
    txHash
    lpTxHash
    createdAt
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useGetTopupHistoryQuery(options: Omit<Urql.UseQueryArgs<GetTopupHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTopupHistoryQuery, GetTopupHistoryQueryVariables>({ query: GetTopupHistoryDocument, ...options });
};
export const GetAllTopupHistoryDocument = gql`
    query GetAllTopupHistory($search: String, $page: Int!) {
  getAllTopupHistory(search: $search, page: $page) {
    id
    amount
    mint {
      id
      name
      chain
      img
    }
    txHash
    lpTxHash
    createdAt
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useGetAllTopupHistoryQuery(options: Omit<Urql.UseQueryArgs<GetAllTopupHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllTopupHistoryQuery, GetAllTopupHistoryQueryVariables>({ query: GetAllTopupHistoryDocument, ...options });
};
export const GetMintsDocument = gql`
    query GetMints {
  getMints {
    id
    name
    chain
    img
    symbol
  }
}
    `;

export function useGetMintsQuery(options?: Omit<Urql.UseQueryArgs<GetMintsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMintsQuery, GetMintsQueryVariables>({ query: GetMintsDocument, ...options });
};
export const GetAutoSwapDocument = gql`
    query GetAutoSwap($organizationId: String!) {
  getAutoSwap(organizationId: $organizationId) {
    fromMint {
      id
      name
      chain
    }
    toMint {
      id
      name
      chain
    }
    finalAddress {
      id
      chain
      address
      name
    }
    immediate
    rollSwap
  }
}
    `;

export function useGetAutoSwapQuery(options: Omit<Urql.UseQueryArgs<GetAutoSwapQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAutoSwapQuery, GetAutoSwapQueryVariables>({ query: GetAutoSwapDocument, ...options });
};
export const GetMeDocument = gql`
    query getMe {
  getMe {
    username
    email
    has2fa
  }
}
    `;

export function useGetMeQuery(options?: Omit<Urql.UseQueryArgs<GetMeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMeQuery, GetMeQueryVariables>({ query: GetMeDocument, ...options });
};
export const GetEthGasWalletDocument = gql`
    query getEthGasWallet {
  getEthGasWallet
}
    `;

export function useGetEthGasWalletQuery(options?: Omit<Urql.UseQueryArgs<GetEthGasWalletQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEthGasWalletQuery, GetEthGasWalletQueryVariables>({ query: GetEthGasWalletDocument, ...options });
};
export const GetFailuresDocument = gql`
    query getFailures {
  getFailures {
    id
    key
    message
    error
    stack
    createdAt
  }
}
    `;

export function useGetFailuresQuery(options?: Omit<Urql.UseQueryArgs<GetFailuresQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFailuresQuery, GetFailuresQueryVariables>({ query: GetFailuresDocument, ...options });
};
export const GetStepLogsDocument = gql`
    query getStepLogs($swapId: String!) {
  getStepLogs(swapId: $swapId) {
    id
    message
    date
  }
}
    `;

export function useGetStepLogsQuery(options: Omit<Urql.UseQueryArgs<GetStepLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetStepLogsQuery, GetStepLogsQueryVariables>({ query: GetStepLogsDocument, ...options });
};
export const UpdateEmailForOrganizationDocument = gql`
    mutation UpdateEmailForOrganization($organizationId: String!, $email: String!) {
  updateEmailForOrganization(organizationId: $organizationId, email: $email) {
    id
    name
    email
  }
}
    `;

export function useUpdateEmailForOrganizationMutation() {
  return Urql.useMutation<UpdateEmailForOrganizationMutation, UpdateEmailForOrganizationMutationVariables>(UpdateEmailForOrganizationDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($userId: String!) {
  resetPassword(userId: $userId) {
    userId
    username
    email
  }
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const CreateUserDocument = gql`
    mutation CreateUser($user: CreateUser!) {
  createUser(user: $user) {
    userId
    username
    email
  }
}
    `;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($name: String!) {
  createOrganization(name: $name) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
  }
}
    `;

export function useCreateOrganizationMutation() {
  return Urql.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument);
};
export const AddUserToOrganizationDocument = gql`
    mutation AddUserToOrganization($organizationId: String!, $userId: String!, $role: Role!) {
  addUserToOrganization(
    organizationId: $organizationId
    userId: $userId
    role: $role
  ) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
  }
}
    `;

export function useAddUserToOrganizationMutation() {
  return Urql.useMutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument);
};
export const UpdateUserRoleInOrganizationDocument = gql`
    mutation updateUserRoleInOrganization($organizationId: String!, $userId: String!, $role: Role!) {
  updateUserRoleInOrganization(
    organizationId: $organizationId
    userId: $userId
    role: $role
  ) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
  }
}
    `;

export function useUpdateUserRoleInOrganizationMutation() {
  return Urql.useMutation<UpdateUserRoleInOrganizationMutation, UpdateUserRoleInOrganizationMutationVariables>(UpdateUserRoleInOrganizationDocument);
};
export const RemoveUserFromOrganizationDocument = gql`
    mutation RemoveUserFromOrganization($organizationId: String!, $userId: String!) {
  removeUserFromOrganization(organizationId: $organizationId, userId: $userId) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
  }
}
    `;

export function useRemoveUserFromOrganizationMutation() {
  return Urql.useMutation<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>(RemoveUserFromOrganizationDocument);
};
export const AddWhitelistDocument = gql`
    mutation AddWhitelist($organizationId: String!, $chain: Chain!, $address: String!, $name: String) {
  addWhitelist(
    organizationId: $organizationId
    chain: $chain
    address: $address
    name: $name
  ) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
  }
}
    `;

export function useAddWhitelistMutation() {
  return Urql.useMutation<AddWhitelistMutation, AddWhitelistMutationVariables>(AddWhitelistDocument);
};
export const RemoveWhitelistDocument = gql`
    mutation RemoveWhitelist($organizationId: String!, $id: Int!) {
  removeWhitelist(organizationId: $organizationId, id: $id) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
  }
}
    `;

export function useRemoveWhitelistMutation() {
  return Urql.useMutation<RemoveWhitelistMutation, RemoveWhitelistMutationVariables>(RemoveWhitelistDocument);
};
export const UpdateWhitelistNameDocument = gql`
    mutation UpdateWhitelistName($id: Int!, $name: String!) {
  updateWhitelistName(id: $id, name: $name) {
    id
    name
  }
}
    `;

export function useUpdateWhitelistNameMutation() {
  return Urql.useMutation<UpdateWhitelistNameMutation, UpdateWhitelistNameMutationVariables>(UpdateWhitelistNameDocument);
};
export const AcceptTopupDocument = gql`
    mutation AcceptTopup($topupId: String!) {
  acceptTopup(topupId: $topupId) {
    id
    amount
    mint {
      id
      name
      chain
      img
      symbol
    }
    txHash
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useAcceptTopupMutation() {
  return Urql.useMutation<AcceptTopupMutation, AcceptTopupMutationVariables>(AcceptTopupDocument);
};
export const RejectTopupDocument = gql`
    mutation RejectTopup($topupId: String!) {
  rejectTopup(topupId: $topupId) {
    id
    amount
    mint {
      id
      name
      chain
      img
      symbol
    }
    txHash
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useRejectTopupMutation() {
  return Urql.useMutation<RejectTopupMutation, RejectTopupMutationVariables>(RejectTopupDocument);
};
export const RedirectTopupDocument = gql`
    mutation RedirectTopup($topupId: String!, $address: String!) {
  redirectTopup(topupId: $topupId, address: $address) {
    id
    amount
    mint {
      id
      name
      chain
      img
      symbol
    }
    txHash
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useRedirectTopupMutation() {
  return Urql.useMutation<RedirectTopupMutation, RedirectTopupMutationVariables>(RedirectTopupDocument);
};
export const ToggleOrganizationAutoApproveDocument = gql`
    mutation ToggleOrganizationAutoApprove($organizationId: String!) {
  toggleOrganizationAutoApprove(organizationId: $organizationId) {
    id
    name
    whitelist {
      id
      chain
      address
      name
    }
    autoApprove
  }
}
    `;

export function useToggleOrganizationAutoApproveMutation() {
  return Urql.useMutation<ToggleOrganizationAutoApproveMutation, ToggleOrganizationAutoApproveMutationVariables>(ToggleOrganizationAutoApproveDocument);
};
export const UpdateAlertForOrganizationDocument = gql`
    mutation updateAlertForOrganization($organizationId: String!, $alertSecret: String!) {
  updateAlertForOrganization(
    organizationId: $organizationId
    alertSecret: $alertSecret
  ) {
    id
    name
    alertSecret
  }
}
    `;

export function useUpdateAlertForOrganizationMutation() {
  return Urql.useMutation<UpdateAlertForOrganizationMutation, UpdateAlertForOrganizationMutationVariables>(UpdateAlertForOrganizationDocument);
};
export const SendTestAlertForOrganizationDocument = gql`
    mutation sendTestAlertForOrganization($organizationId: String!) {
  sendTestAlertForOrganization(organizationId: $organizationId)
}
    `;

export function useSendTestAlertForOrganizationMutation() {
  return Urql.useMutation<SendTestAlertForOrganizationMutation, SendTestAlertForOrganizationMutationVariables>(SendTestAlertForOrganizationDocument);
};
export const CreateAutoSwapDocument = gql`
    mutation createAutoSwap($fromMintId: Int!, $toMintId: Int!, $endAddress: Int!, $organizationId: String!, $immediate: Boolean!, $hoursBeforeExecution: Int, $rollSwap: Boolean!) {
  createAutoSwap(
    fromMintId: $fromMintId
    toMintId: $toMintId
    endAddress: $endAddress
    organizationId: $organizationId
    immediate: $immediate
    hoursBeforeExecution: $hoursBeforeExecution
    rollSwap: $rollSwap
  ) {
    fromMint {
      id
      name
      chain
    }
    toMint {
      id
      name
      chain
    }
    finalAddress {
      id
      chain
      address
      name
    }
    immediate
  }
}
    `;

export function useCreateAutoSwapMutation() {
  return Urql.useMutation<CreateAutoSwapMutation, CreateAutoSwapMutationVariables>(CreateAutoSwapDocument);
};
export const DeleteAutoSwapDocument = gql`
    mutation deleteAutoSwap($organizationId: String!) {
  deleteAutoSwap(organizationId: $organizationId)
}
    `;

export function useDeleteAutoSwapMutation() {
  return Urql.useMutation<DeleteAutoSwapMutation, DeleteAutoSwapMutationVariables>(DeleteAutoSwapDocument);
};
export const ExecuteAutoSwapDocument = gql`
    mutation executeAutoSwap($organizationId: String!) {
  executeAutoSwap(organizationId: $organizationId)
}
    `;

export function useExecuteAutoSwapMutation() {
  return Urql.useMutation<ExecuteAutoSwapMutation, ExecuteAutoSwapMutationVariables>(ExecuteAutoSwapDocument);
};
export const ToggleTakeExtraFeeDocument = gql`
    mutation toggleTakeExtraFee($organizationId: String!) {
  toggleTakeExtraFee(organizationId: $organizationId) {
    id
    name
    takeExtraFee
  }
}
    `;

export function useToggleTakeExtraFeeMutation() {
  return Urql.useMutation<ToggleTakeExtraFeeMutation, ToggleTakeExtraFeeMutationVariables>(ToggleTakeExtraFeeDocument);
};
export const ZeroOutBalanceDocument = gql`
    mutation zeroOutBalance($organizationId: String!, $mintId: Int!) {
  zeroOutBalance(organizationId: $organizationId, mintId: $mintId)
}
    `;

export function useZeroOutBalanceMutation() {
  return Urql.useMutation<ZeroOutBalanceMutation, ZeroOutBalanceMutationVariables>(ZeroOutBalanceDocument);
};
export const RequestTwoFactorAuthDocument = gql`
    mutation requestTwoFactorAuth {
  requestTwoFactorAuth
}
    `;

export function useRequestTwoFactorAuthMutation() {
  return Urql.useMutation<RequestTwoFactorAuthMutation, RequestTwoFactorAuthMutationVariables>(RequestTwoFactorAuthDocument);
};
export const SetupTwoFactorAuthDocument = gql`
    mutation setupTwoFactorAuth($secret: String!) {
  setupTwoFactorAuth(secret: $secret) {
    userId
    username
    email
  }
}
    `;

export function useSetupTwoFactorAuthMutation() {
  return Urql.useMutation<SetupTwoFactorAuthMutation, SetupTwoFactorAuthMutationVariables>(SetupTwoFactorAuthDocument);
};
export const RetryFailureDocument = gql`
    mutation retryFailure($id: Int!) {
  retryFailure(id: $id)
}
    `;

export function useRetryFailureMutation() {
  return Urql.useMutation<RetryFailureMutation, RetryFailureMutationVariables>(RetryFailureDocument);
};
export const DeleteFailureDocument = gql`
    mutation deleteFailure($id: Int!) {
  deleteFailure(id: $id)
}
    `;

export function useDeleteFailureMutation() {
  return Urql.useMutation<DeleteFailureMutation, DeleteFailureMutationVariables>(DeleteFailureDocument);
};


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Admin: ResolverTypeWrapper<Admin>;
  AdminLog: ResolverTypeWrapper<AdminLog>;
  AutoSwap: ResolverTypeWrapper<AutoSwap>;
  Balance: ResolverTypeWrapper<Balance>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Chain: Chain;
  CreateUser: CreateUser;
  Decision: Decision;
  DepositAddress: ResolverTypeWrapper<DepositAddress>;
  Failure: ResolverTypeWrapper<Failure>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Mint: ResolverTypeWrapper<Mint>;
  Mutation: ResolverTypeWrapper<{}>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationPermission: ResolverTypeWrapper<OrganizationPermission>;
  OrganizationWithPendingTopups: ResolverTypeWrapper<OrganizationWithPendingTopups>;
  Query: ResolverTypeWrapper<{}>;
  Role: Role;
  StepLog: ResolverTypeWrapper<StepLog>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Swap: ResolverTypeWrapper<Swap>;
  SwapStatus: SwapStatus;
  SwapStep: ResolverTypeWrapper<SwapStep>;
  Topup: ResolverTypeWrapper<Topup>;
  UpdateUserOrgs: UpdateUserOrgs;
  User: ResolverTypeWrapper<User>;
  UserInOrg: ResolverTypeWrapper<UserInOrg>;
  UserLog: ResolverTypeWrapper<UserLog>;
  UserWithOrg: ResolverTypeWrapper<UserWithOrg>;
  Whitelist: ResolverTypeWrapper<Whitelist>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Admin: Admin;
  AdminLog: AdminLog;
  AutoSwap: AutoSwap;
  Balance: Balance;
  Boolean: Scalars['Boolean']['output'];
  CreateUser: CreateUser;
  DepositAddress: DepositAddress;
  Failure: Failure;
  Int: Scalars['Int']['output'];
  Mint: Mint;
  Mutation: {};
  Organization: Organization;
  OrganizationPermission: OrganizationPermission;
  OrganizationWithPendingTopups: OrganizationWithPendingTopups;
  Query: {};
  StepLog: StepLog;
  String: Scalars['String']['output'];
  Swap: Swap;
  SwapStep: SwapStep;
  Topup: Topup;
  UpdateUserOrgs: UpdateUserOrgs;
  User: User;
  UserInOrg: UserInOrg;
  UserLog: UserLog;
  UserWithOrg: UserWithOrg;
  Whitelist: Whitelist;
};

export type AdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['Admin'] = ResolversParentTypes['Admin']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  has2fa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminLog'] = ResolversParentTypes['AdminLog']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoSwapResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoSwap'] = ResolversParentTypes['AutoSwap']> = {
  finalAddress?: Resolver<ResolversTypes['Whitelist'], ParentType, ContextType>;
  fromMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  immediate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rollSwap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  toMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Balance'] = ResolversParentTypes['Balance']> = {
  credit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DepositAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['DepositAddress'] = ResolversParentTypes['DepositAddress']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['Failure'] = ResolversParentTypes['Failure']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MintResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mint'] = ResolversParentTypes['Mint']> = {
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptTopup?: Resolver<ResolversTypes['Topup'], ParentType, ContextType, RequireFields<MutationAcceptTopupArgs, 'topupId'>>;
  addUserToOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationAddUserToOrganizationArgs, 'organizationId' | 'role' | 'userId'>>;
  addWhitelist?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationAddWhitelistArgs, 'address' | 'chain' | 'organizationId'>>;
  createAutoSwap?: Resolver<ResolversTypes['AutoSwap'], ParentType, ContextType, RequireFields<MutationCreateAutoSwapArgs, 'endAddress' | 'fromMintId' | 'immediate' | 'organizationId' | 'rollSwap' | 'toMintId'>>;
  createOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'name'>>;
  createUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'user'>>;
  deleteAutoSwap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAutoSwapArgs, 'organizationId'>>;
  deleteFailure?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteFailureArgs, 'id'>>;
  executeAutoSwap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationExecuteAutoSwapArgs, 'organizationId'>>;
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  redirectTopup?: Resolver<ResolversTypes['Topup'], ParentType, ContextType, RequireFields<MutationRedirectTopupArgs, 'address' | 'topupId'>>;
  rejectTopup?: Resolver<ResolversTypes['Topup'], ParentType, ContextType, RequireFields<MutationRejectTopupArgs, 'topupId'>>;
  removeUserFromOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationRemoveUserFromOrganizationArgs, 'organizationId' | 'userId'>>;
  removeWhitelist?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationRemoveWhitelistArgs, 'id' | 'organizationId'>>;
  requestTwoFactorAuth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resetPassword?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'userId'>>;
  retryFailure?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRetryFailureArgs, 'id'>>;
  sendTestAlertForOrganization?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendTestAlertForOrganizationArgs, 'organizationId'>>;
  setupTwoFactorAuth?: Resolver<ResolversTypes['Admin'], ParentType, ContextType, RequireFields<MutationSetupTwoFactorAuthArgs, 'secret'>>;
  toggleOrganizationAutoApprove?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationToggleOrganizationAutoApproveArgs, 'organizationId'>>;
  toggleTakeExtraFee?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationToggleTakeExtraFeeArgs, 'organizationId'>>;
  updateAlertForOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationUpdateAlertForOrganizationArgs, 'alertSecret' | 'organizationId'>>;
  updateEmailForOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationUpdateEmailForOrganizationArgs, 'email' | 'organizationId'>>;
  updateUserRoleInOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationUpdateUserRoleInOrganizationArgs, 'organizationId' | 'role' | 'userId'>>;
  updateWhitelistName?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationUpdateWhitelistNameArgs, 'id' | 'name'>>;
  zeroOutBalance?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationZeroOutBalanceArgs, 'mintId' | 'organizationId'>>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  alertSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  autoApprove?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  depositAddresses?: Resolver<Array<ResolversTypes['DepositAddress']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  takeExtraFee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  whitelist?: Resolver<Array<ResolversTypes['Whitelist']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationPermission'] = ResolversParentTypes['OrganizationPermission']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationWithPendingTopupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationWithPendingTopups'] = ResolversParentTypes['OrganizationWithPendingTopups']> = {
  autoApprove?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasBalance?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPendingTopups?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  takeExtraFee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  whitelist?: Resolver<Array<ResolversTypes['Whitelist']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  getAllOrganizations?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  getAllTopupHistory?: Resolver<Array<ResolversTypes['Topup']>, ParentType, ContextType, RequireFields<QueryGetAllTopupHistoryArgs, 'page'>>;
  getAllUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  getAutoSwap?: Resolver<Maybe<ResolversTypes['AutoSwap']>, ParentType, ContextType, RequireFields<QueryGetAutoSwapArgs, 'organizationId'>>;
  getBalance?: Resolver<Array<ResolversTypes['Balance']>, ParentType, ContextType, RequireFields<QueryGetBalanceArgs, 'organizationId'>>;
  getEthGasWallet?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  getFailures?: Resolver<Array<ResolversTypes['Failure']>, ParentType, ContextType>;
  getLogHistoryOfAdmin?: Resolver<Array<ResolversTypes['AdminLog']>, ParentType, ContextType, RequireFields<QueryGetLogHistoryOfAdminArgs, 'page'>>;
  getLogHistoryOfUser?: Resolver<Array<ResolversTypes['UserLog']>, ParentType, ContextType, RequireFields<QueryGetLogHistoryOfUserArgs, 'page' | 'userId'>>;
  getMe?: Resolver<ResolversTypes['Admin'], ParentType, ContextType>;
  getMints?: Resolver<Array<ResolversTypes['Mint']>, ParentType, ContextType>;
  getNonce?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  getOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<QueryGetOrganizationArgs, 'organizationId'>>;
  getOrganizations?: Resolver<Array<ResolversTypes['OrganizationWithPendingTopups']>, ParentType, ContextType, RequireFields<QueryGetOrganizationsArgs, 'page'>>;
  getStepLogs?: Resolver<Array<ResolversTypes['StepLog']>, ParentType, ContextType, RequireFields<QueryGetStepLogsArgs, 'swapId'>>;
  getSwap?: Resolver<ResolversTypes['Swap'], ParentType, ContextType, RequireFields<QueryGetSwapArgs, 'swapId'>>;
  getSwaps?: Resolver<Array<ResolversTypes['Swap']>, ParentType, ContextType, RequireFields<QueryGetSwapsArgs, 'page'>>;
  getSwapsOfOrganization?: Resolver<Array<ResolversTypes['Swap']>, ParentType, ContextType, RequireFields<QueryGetSwapsOfOrganizationArgs, 'organizationId' | 'page'>>;
  getTopupHistory?: Resolver<Array<ResolversTypes['Topup']>, ParentType, ContextType, RequireFields<QueryGetTopupHistoryArgs, 'organizationId' | 'page'>>;
  getTransientTopups?: Resolver<Array<ResolversTypes['Topup']>, ParentType, ContextType, RequireFields<QueryGetTransientTopupsArgs, 'organizationId'>>;
  getUser?: Resolver<ResolversTypes['UserWithOrg'], ParentType, ContextType, RequireFields<QueryGetUserArgs, 'userId'>>;
  getUsersOfOrganization?: Resolver<Array<ResolversTypes['UserInOrg']>, ParentType, ContextType, RequireFields<QueryGetUsersOfOrganizationArgs, 'organizationId' | 'page'>>;
};

export type StepLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['StepLog'] = ResolversParentTypes['StepLog']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  swapId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwapResolvers<ContextType = any, ParentType extends ResolversParentTypes['Swap'] = ResolversParentTypes['Swap']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  depositAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SwapStatus'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['SwapStep']>, ParentType, ContextType>;
  toAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  txHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwapStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwapStep'] = ResolversParentTypes['SwapStep']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isPending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Topup'] = ResolversParentTypes['Topup']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decision?: Resolver<ResolversTypes['Decision'], ParentType, ContextType>;
  decisionAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finalizedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lpTxHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInOrgResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInOrg'] = ResolversParentTypes['UserInOrg']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLog'] = ResolversParentTypes['UserLog']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserWithOrgResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserWithOrg'] = ResolversParentTypes['UserWithOrg']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizations?: Resolver<Array<ResolversTypes['OrganizationPermission']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WhitelistResolvers<ContextType = any, ParentType extends ResolversParentTypes['Whitelist'] = ResolversParentTypes['Whitelist']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['Chain'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Admin?: AdminResolvers<ContextType>;
  AdminLog?: AdminLogResolvers<ContextType>;
  AutoSwap?: AutoSwapResolvers<ContextType>;
  Balance?: BalanceResolvers<ContextType>;
  DepositAddress?: DepositAddressResolvers<ContextType>;
  Failure?: FailureResolvers<ContextType>;
  Mint?: MintResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationPermission?: OrganizationPermissionResolvers<ContextType>;
  OrganizationWithPendingTopups?: OrganizationWithPendingTopupsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  StepLog?: StepLogResolvers<ContextType>;
  Swap?: SwapResolvers<ContextType>;
  SwapStep?: SwapStepResolvers<ContextType>;
  Topup?: TopupResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserInOrg?: UserInOrgResolvers<ContextType>;
  UserLog?: UserLogResolvers<ContextType>;
  UserWithOrg?: UserWithOrgResolvers<ContextType>;
  Whitelist?: WhitelistResolvers<ContextType>;
};

